import { render, staticRenderFns } from "./groupdetail.vue?vue&type=template&id=1f056374&scoped=true&"
import script from "./groupdetail.vue?vue&type=script&lang=js&"
export * from "./groupdetail.vue?vue&type=script&lang=js&"
import style0 from "./groupdetail.vue?vue&type=style&index=0&id=1f056374&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f056374",
  null
  
)

export default component.exports